import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//Components
import GridSkeleton from "./types/GridSkeleton";
import StandardGridRecipe from "./types/StandardGridRecipe";
import StandardGridMedia from "./types/StandardGridMedia";
import StandardGridText from "./types/StandardGridText";

//Actions
import { getPostData } from "../../../actions/feed";

//Selectors
import { getPostDataFromCache } from "../../../selectors/postSelectors";
const StandardPostGridManager = ({ post, getPostData, feed }) => {
  const requestedRef = useRef(false);

  const postId = post.postid;
  const repostUserId = post.repostuser || null;
  const cachedData = getPostDataFromCache(feed, postId, repostUserId);
  const errorCooldownTs = feed?.postCache?.errors?.[postId];
  const inCooldown = errorCooldownTs && errorCooldownTs > Date.now();

  useEffect(() => {
    requestedRef.current = false;
  }, [postId, repostUserId]);

  useEffect(() => {
    if (!cachedData && !inCooldown && !requestedRef.current) {
      requestedRef.current = true;
      getPostData(postId, -1, repostUserId);
    }
  }, [cachedData, inCooldown, getPostData, postId, repostUserId]);

  const shouldShowSkeleton = !cachedData && !inCooldown;
  const hasError = !cachedData && inCooldown;

  return (
    <div>
      {hasError ? null : shouldShowSkeleton ? (
        <GridSkeleton />
      ) : cachedData ? (
        <>
          {cachedData.type === "recipe" && (
            <StandardGridRecipe recipeid={cachedData && cachedData.recipe && cachedData.recipe.id} />
          )}
          {cachedData.type === "media" && <StandardGridMedia post={cachedData} />}
          {cachedData.type === "text" && <StandardGridText post={cachedData} />}
        </>
      ) : null}
    </div>
  );
};

StandardPostGridManager.propTypes = {
  post: PropTypes.object.isRequired,
  getPostData: PropTypes.func.isRequired,
  feed: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  feed: state.feed,
});

export default connect(mapStateToProps, { getPostData })(StandardPostGridManager);
